import React from "react";
import { Navbar } from "./components/Navbar";
import { Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { Booking } from "./pages/Booking";
import { ContactUs } from "./pages/ContactUs";
import { Product } from "./pages/Product";
import { AboutUs } from "./pages/AboutUs";
import { Footer } from "./components/Footer";
import SocialMedia from "./pages/SocialMedia";
import PaymentSuccess from "./components/PaymentSuccess";
import Distrubuter from "./pages/Distrubuter";
import { MissionVision } from "./components/MissionVision";
import Event from "./components/Event";
import { TermsAndConditions } from "./components/TermsAndConditions";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { RentKGVBike } from "./pages/RentKGVBike";
import { Purchagekgvbike } from "./pages/Purchagekgvbike";
import PayOneRupee from "./pages/PayOneRupee";
import KgvbikeOrder from "./pages/KgvbikeOrder";
import OrderKgvHelmet from './pages/OrderKgvHelmet';
import HelmetPaymentSuccess from './components/HelmetPaymentSuccess';
import { Reviews } from './pages/Reviews';
import ScrollToTop from "./components/ScrollToTop";

import ReactGA from "react-ga4";
ReactGA.initialize("G-6SVB4XLK5H");

const App = () => {
  return (
    <div className="overflow-hidden">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/event" element={<Event />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/rentkgvbike" element={<RentKGVBike />} />
        <Route path="/Purchagekgvbike" element={<Purchagekgvbike />} />
        <Route path="/ContactUs" element={<ContactUs />} />
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
        <Route path="/distribution" element={<Distrubuter />} />
        <Route path="/socialmedia" element={<SocialMedia />} />
        <Route path="/KgvkitOrder" element={<PayOneRupee />} />
        <Route path="/KgvbikeOrder" element={<KgvbikeOrder />} />
        <Route path="/MissionVision" element={<MissionVision />} />
        <Route path="/Termsandconditions" element={<TermsAndConditions />} />
        <Route path="/OrderKgvHelmet" element={<OrderKgvHelmet />} />
        <Route path="/Privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/helmet-payment-success" element={<HelmetPaymentSuccess />} />
      </Routes>
      <Footer />
    </div>
  )
};

export default App;